import { AnimalOverview } from "../components/AnimalOverview";

/**
 * "Dier aanwezig" route wrapper — the present-animals card overview (Jmix `DierAttendanceOverview`
 * migration). A thin shell that wires the reusable {@link AnimalOverview} to the present-animals feed
 * and the animal-detail navigation. Kept as its own route (distinct from the general animals list) per
 * the migration plan; the overview itself is parameterised so the general list can adopt it later.
 */
export function AnimalPresentView({ onOpenAnimal }: { onOpenAnimal: (id: string) => void }) {
  return <AnimalOverview endpoint="animals/present" onOpenAnimal={onOpenAnimal} showStatCards showFosterToggle />;
}
